/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Accolade } from './Accolade';
import {
    AccoladeFromJSON,
    AccoladeFromJSONTyped,
    AccoladeToJSON,
    AccoladeToJSONTyped,
} from './Accolade';

/**
 * 
 * @export
 * @interface GetAccoladeOutputBody
 */
export interface GetAccoladeOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof GetAccoladeOutputBody
     */
    readonly $schema?: string;
    /**
     * 
     * @type {Accolade}
     * @memberof GetAccoladeOutputBody
     */
    accolade: Accolade;
}

/**
 * Check if a given object implements the GetAccoladeOutputBody interface.
 */
export function instanceOfGetAccoladeOutputBody(value: object): value is GetAccoladeOutputBody {
    if (!('accolade' in value) || value['accolade'] === undefined) return false;
    return true;
}

export function GetAccoladeOutputBodyFromJSON(json: any): GetAccoladeOutputBody {
    return GetAccoladeOutputBodyFromJSONTyped(json, false);
}

export function GetAccoladeOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccoladeOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accolade': AccoladeFromJSON(json['accolade']),
    };
}

export function GetAccoladeOutputBodyToJSON(json: any): GetAccoladeOutputBody {
    return GetAccoladeOutputBodyToJSONTyped(json, false);
}

export function GetAccoladeOutputBodyToJSONTyped(value?: Omit<GetAccoladeOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accolade': AccoladeToJSON(value['accolade']),
    };
}

